const STORAGE_PREFIX = 'analyse:responding:';
const MAX_AGE_MS = 10 * 60 * 1000;

export function markAnalyseChatResponding(chatId: string): void {
  const id = chatId?.trim();
  if (!id || typeof sessionStorage === 'undefined') return;
  try {
    sessionStorage.setItem(`${STORAGE_PREFIX}${id}`, String(Date.now()));
  } catch {
    // Ignore quota / private mode failures.
  }
}

export function clearAnalyseChatResponding(chatId: string): void {
  const id = chatId?.trim();
  if (!id || typeof sessionStorage === 'undefined') return;
  try {
    sessionStorage.removeItem(`${STORAGE_PREFIX}${id}`);
  } catch {
    // Ignore.
  }
}

/** True when this tab recently started a Mia reply for the chat (refresh / nav recovery). */
export function hasLocalAnalyseChatResponding(chatId: string): boolean {
  const id = chatId?.trim();
  if (!id || typeof sessionStorage === 'undefined') return false;
  try {
    const raw = sessionStorage.getItem(`${STORAGE_PREFIX}${id}`);
    if (!raw) return false;
    const startedAt = Number(raw);
    if (!Number.isFinite(startedAt) || Date.now() - startedAt > MAX_AGE_MS) {
      sessionStorage.removeItem(`${STORAGE_PREFIX}${id}`);
      return false;
    }
    return true;
  } catch {
    return false;
  }
}
